import React, { useState, useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AppContext } from '../../App';
import api from './AuthenticationServices';
import LoadingPanel from '../Shared/LoadingPanel';
import { useTitle } from '../Shared/CustomHooks';

const Login = () => {
    useTitle('Login');
    const context = useContext(AppContext);
    let rlocation = useLocation();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loginFailed, setLoginFailed] = useState(false);
    const [loginRequest, setLoginRequest] = useState(false);
    const [isLoading, setLoading] = useState(false);

    //Must useEffect to update global context after login
    useEffect(() => {
        //Login to OSU AD
        if (loginRequest && username && password) {
            setLoading(true)
            api.login(username, password).then(data => {
                if (data != null && data.isAuthenticated) {
                    context.updateContext(data);
                    setLoading(false)
                }
                else {
                    throw data;
                }
            }).catch((err) => {
                console.log(err);
                context.updateContext(null);
                setLoginFailed(true);
                setLoading(false)
            });
        }
    }, [loginRequest]);

    const handleChangeUserName = (e) => {
        setUsername(e.target.value);
        setLoginFailed(false);
        setLoginRequest(false);
    }

    const handleChangePassword = (e) => {
        setPassword(e.target.value);
        setLoginFailed(false);
        setLoginRequest(false);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoginFailed(false);
        setLoginRequest(true);
    }

    const from = rlocation.state?.from || '/ErrorsQueue';
    
    if (context.isAuthenticated === true) {
        return (<Navigate to={from} replace={true} />);
    }
    else if (context.authenticateAgency === "OSU") {
        const path = rlocation.pathname + rlocation.search + rlocation.hash;
        return <Navigate to='/OsuLogin' replace={true} state={{ from: path }} />
    }
    else {
        return (
            <>
                <p className="login-disclaimer">You are accessing an OSUWMC information system. Use indicates consent to monitoring, recording, and auditing of activity. Unauthorized use is prohibited and subject to criminal and civil penalties.</p>
                <article className="content transparent login-osumc-osu">
                    <div className="login-option">
                        <form name="form" onSubmit={handleSubmit}>
                            <h1>Wexner Medical Center Login</h1>
                            <div className={'form-group' + (loginRequest && !username ? ' has-error' : '')}>
                                <label htmlFor="username">Username</label>
                                <input type="text" className="form-control" name="username" id="username" value={username} onChange={handleChangeUserName} aria-required="true" aria-invalid={loginRequest && !username} />
                                {loginRequest && !username && <div className="help-block field-validation-error" aria-live="assertive" aria-atomic="true">Username is required</div>}
                            </div>
                            <div className={'form-group' + (loginRequest && !password ? ' has-error' : '')}>
                                <label htmlFor="password">Password</label>
                                <input type="password" className="form-control" name="password" id="password" value={password} onChange={handleChangePassword} aria-required="true" aria-invalid={loginRequest && !password} />
                                {loginRequest && !password && <div className="help-block field-validation-error" aria-live="assertive" aria-atomic="true">Password is required</div>}
                            </div>
                            <div className="form-group">
                                <button className="submit">Login</button>
                            </div>
                            {loginRequest && loginFailed && <div className="help-block field-validation-error" aria-live="assertive" aria-atomic="true">Invalid username or password</div>}
                        </form>
                    </div>
                </article>
                {isLoading && <LoadingPanel />}
            </>
        );
    }
};

export default Login;
